// extracted by mini-css-extract-plugin
export var electronic = "styles-module--electronic--Yo+L3";
export var hasPanels = "styles-module--has-panels--1PAxl";
export var homePanels = "styles-module--home-panels--4E0cA";
export var image = "styles-module--image--jz0Wq";
export var imageBg = "styles-module--image-bg--nXnhd";
export var inner = "styles-module--inner--KLmER";
export var logo = "styles-module--logo--o2cJh";
export var open = "styles-module--open--sBdGg";
export var passive = "styles-module--passive--EIdax";